import { useEffect, useState } from 'react';
import { DefaultClient } from '../../../types';

export function useFontDisplayName(
  client: DefaultClient | null,
  cssFontFamily: string,
): string | undefined {
  const [displayName, setDisplayName] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (!client?.info?.getFontFamilyDisplayName) {
      setDisplayName(undefined);
      return;
    }

    let cancelled = false;

    client.info
      .getFontFamilyDisplayName(cssFontFamily)
      .then((name) => {
        if (!cancelled) {
          setDisplayName(name);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setDisplayName(undefined);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [client, cssFontFamily]);

  return displayName;
}
